import { routes } from '@blockpulse3/data/shared';
import { useLocation } from 'react-router-dom';
import { SettingsNavAdmin } from './SettingsNavAdmin';
import { SettingsNavCompany } from './SettingsNavCompany';
import { SettingsNavUser } from './SettingsNavUser';

type Props = unknown;

/**
 * SettingsNav.
 * Renders navigation links on the Sidebar.
 *
 * @returns {JSX.Element}
 */
export function SettingsNav(): JSX.Element {
  const { pathname } = useLocation();
  const isUserWorkspace = pathname.startsWith(routes.me.href);
  const isAdminWorkspace = pathname.startsWith(routes.admin.href);

  if (isAdminWorkspace) return <SettingsNavAdmin />;
  return isUserWorkspace ? <SettingsNavUser /> : <SettingsNavCompany />;
}

export type SettingsNavProps = Props;
